"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachState = exports.ProviderType = void 0;
var ProviderType;
(function (ProviderType) {
    ProviderType["Context"] = "Context";
    ProviderType["FunctionLibrary"] = "FunctionLibrary";
    ProviderType["Template"] = "Template";
})(ProviderType || (exports.ProviderType = ProviderType = {}));
var AttachState;
(function (AttachState) {
    AttachState["Above"] = "above";
    AttachState["None"] = "none";
    AttachState["Self"] = "self";
    AttachState["System"] = "system";
})(AttachState || (exports.AttachState = AttachState = {}));
